import _ from 'lodash';
import {
  getProjectConfigData,
  getProjectEstimationFields,
  isAllObjectValuesZero
} from './services/projects.services';
import { SUMMARY_PERIODS } from './projects.consts';

import {
  withProject,
  withPeopleEffort,
  withInvestmentBreakdown,
  withDelivery,
  WithProjectExtended,
  withNoProjectExtended,
  withDefaultCursor,
  withMenuButton,
  withNewProject,
  withNewProjectNoData,
  withProjectNoData,
  withLoadingProject
} from './projects.builder.steps';
import { jiraViewer } from 'components/hooks/PM/pm-provider-viewers';

export const builder = ({
  project = {},
  selectedPeriod,
  selectedTimeRange,
  investmentColorsMap,
  onDeleteProject,
  pmSensorAuthId,
  isCanConfigProjects,
  toggleModal = _.noop,
  toggleSnackBar = _.noop,
  projectsEstimationFields = {},
  onSaveClick,
  addProjectToFavorites,
  removeProjectFromFavorites,
  isFavoriteProject,
  type,
  pmViewer = jiraViewer
}) => {
  let row = {};
  const { issuesChartConfig = {}, projectConfig } =
    getProjectConfigData(project);
  const { investment_type, delivery_type } = getProjectEstimationFields(
    projectsEstimationFields,
    project
  );

  const build = () => {
    return row;
  };

  const {
    total_investment_counts: totalInvestmentCounts,
    total_investment_story_points: totalInvestmentStoryPoints,
    total_planning_counts: totalPlanningCounts,
    total_planning_story_points: totalPlanningStoryPoints,
    iterations
  } = project;

  const isLastIteration = selectedPeriod === SUMMARY_PERIODS.last_sprint;

  const buildLoadingTableRow = () => {
    row = {};
    withDefaultCursor(row);
    withNoProjectExtended(row);
    withProject(row, {
      project,
      isLastIteration,
      iterations,
      addProjectToFavorites,
      removeProjectFromFavorites,
      isFavoriteProject
    });
    withLoadingProject(row, { type });
    return build();
  };
  const buildNoMatchResultsRow = () => {
    row = {};
    withDefaultCursor(row);
    withNoProjectExtended(row);
    withLoadingProject(row, { type, withoutAnimation: true });

    return build();
  };

  const buildTableRow = () => {
    const noInvestmentData =
      isAllObjectValuesZero(totalInvestmentCounts) &&
      isAllObjectValuesZero(totalInvestmentStoryPoints);
    const noProjectData =
      isAllObjectValuesZero(totalPlanningCounts) &&
      isAllObjectValuesZero(totalPlanningStoryPoints);

    row = {};

    if (noProjectData) {
      withDefaultCursor(row);
      withNoProjectExtended(row);
      withProject(row, {
        project,
        isLastIteration,
        iterations,
        addProjectToFavorites,
        removeProjectFromFavorites,
        isFavoriteProject
      });
      withProjectNoData(row, { selectedPeriod });
      withMenuButton(row, {
        isCanConfigProjects,
        project,
        onDeleteProject,
        pmSensorAuthId,
        toggleModal,
        onSaveClick,
        toggleSnackBar
      });
    } else {
      WithProjectExtended(row, {
        project,
        selectedPeriod,
        selectedTimeRange
      });
      withProject(row, {
        project,
        isLastIteration,
        iterations,
        addProjectToFavorites,
        removeProjectFromFavorites,
        isFavoriteProject
      });
      withPeopleEffort(row, {
        project,
        projectConfig,
        isLastIteration
      });
      withInvestmentBreakdown(row, {
        investmentData:
          investment_type === 'counts'
            ? totalInvestmentCounts
            : totalInvestmentStoryPoints,
        noInvestmentData,
        investmentColorsMap,
        pmViewer
      });
      withDelivery(row, {
        project,
        issuesChartConfig,
        isLastIteration,
        deliveryType: delivery_type
      });
      withMenuButton(row, {
        isCanConfigProjects,
        project,
        onDeleteProject,
        pmSensorAuthId,
        toggleModal,
        onSaveClick,
        toggleSnackBar
      });
    }

    return build();
  };

  const buildNewProjectRow = () => {
    row = {};
    withDefaultCursor(row);
    withNoProjectExtended(row);
    withNewProject(row, { project });
    withNewProjectNoData(row);

    return build();
  };

  return {
    buildTableRow,
    buildNewProjectRow,
    buildLoadingTableRow,
    buildNoMatchResultsRow
  };
};
